/* eslint-disable import/no-unresolved */
import { useMutation } from '@apollo/client';
import {
    Button, Modal, ModalBody, ModalFooter,
} from 'appkit-react';
import { useState } from 'react';

import { CREATE_PROJECT_FILE_MAPPING } from 'Apollo/Mutations';
import FileExplorerContainer from 'views/DataRecon/FileExplorer/containers/FileExplorerContainer';

import './add-files-to-project.scss';

const AddFilesFlag = true;

const AddFilesToProjectModal = ({
    visible, setVisible, projectId, tenantId, refetch, setToastMessage,
}) => {
    const [filesToAdd, setfilesToAdd] = useState([]);
    const [createProjectFileMapping, { loading }] = useMutation(CREATE_PROJECT_FILE_MAPPING);

    const onSave = async () => {
        await createProjectFileMapping({
            variables: {
                input: {
                    projectId: parseInt(projectId, 10),
                    tenantId: parseInt(tenantId, 10),
                    fileIdArr: filesToAdd,
                },
            },
        }).then(() => setToastMessage('Files are added to the project.'));
        refetch();
        setVisible(false);
    };

    return (
        <Modal
            visible={visible}
            onCancel={() => { setVisible(false); }}
            style={{ marginLeft: '-17rem', width: '69rem' }}
            backdropClosable={false}
        >
            <ModalBody style={{ padding: 0, marginTop: '1rem' }}>
                <div className="project-details-file-explorer">
                    <FileExplorerContainer tenantId={tenantId} AddFilesFlag={AddFilesFlag} setfilesToAdd={setfilesToAdd} />
                </div>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'flex-end' }}>
                <Button kind="secondary" onClick={() => { setVisible(false); }} size="lg"> CANCEL </Button>
                <Button kind="primary" size="lg" onClick={onSave} isLoading={loading} disabled={filesToAdd.length === 0}> ADD FILES </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddFilesToProjectModal;
